<app-lang-switch position="absolute"></app-lang-switch>

<div class="container flex">
  <div [formGroup]="loginForm" class="widget loginFormContainer p-6 flex flex-column gap-4">
    <img src="assets/images/logo.png" alt="Logo" class="appLogo" />

    <div class="flex flex-column gap-2 mb-3">
      <label for="username" class="font-semibold">{{ "auth.login.username" | translate }}</label>
      <input pInputText id="username" formControlName="username" autocomplete="off" (keyup)="onKeyUp($event)" />
    </div>
    <div class="flex flex-column gap-2 mb-3 relative">
      <label for="password" class="font-semibold">{{ "auth.login.password" | translate }}</label>
      <input
        pInputText
        id="password"
        formControlName="password"
        [type]="passwordVisible() ? 'text' : 'password'"
        autocomplete="off"
        (keyup)="onKeyUp($event)"
        class="pr-5"
      />
      <app-svg-icon
        (click)="togglePasswordVisibility()"
        iconName="eye"
        iconColor="primary"
        style="right: 1rem; top: 2.1rem"
        class="p-link absolute"
        tabindex="-1"
      />
    </div>
    <div class="flex justify-content-end">
      <a [routerLink]="['/forgotPassword']">{{ "auth.login.forgot_password" | translate }}</a>
    </div>
    @if (loading()) {
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    } @else {
      <app-button (click)="login()" buttonText="auth.login.login_button" [block]="true" [disabled]="!loginForm.valid">
      </app-button>
    }
  </div>
</div>
